import React from 'react'

const Abatacepte =
    <>
        reações a reações no local da aplicação da injeção ou reações alérgicas durante ou
        após a infusão, dor de cabeça, nasofaringite, enjoos e risco aumentado a uma variedade
        de infecções, como herpes-zoster, infecção urinária, gripe, pneumonia, bronquite e
        infecção localizada. A tuberculose pode ser reativada ou iniciada com o uso do
        medicamento e aumento de risco para alguns tipos de câncer.
    </>

const Adalimumabe =
    <>
        reações no local da aplicação da injeção como dor e coceiras, dor de cabeça, tosse,
        náusea, vômitos, febre, cansaço, alteração na pressão arterial; reações mais graves:
        infecções oportunistas fúngicas e bacterianas do trato respiratório superior, como
        faringite, rinite, laringite, tuberculose, histoplasmose, aspergilose e nocardiose,
        podendo, em casos raros, ser fatal.
    </>

const Azatioprina =
    <>
        diminuição das células brancas, vermelhas e plaquetas do sangue, náusea, vômitos,
        diarreia, dor abdominal, fezes com sangue, problemas no fígado, febre, calafrios,
        diminuição de apetite, vermelhidão de pele, perda de cabelo, aftas, dores nas
        juntas, problemas nos olhos (retinopatia), falta de ar, pressão baixa.
    </>
const Baricitinibe =
    <>
        aumento da taxa de infecções, neutropenia, linfopenia, reativação viral,
        diminuições dos níveis de hemoglobina, aumentos nos parâmetros de
        lipídeos, aumento de aminotransferases, trombose venosa profunda,
        embolia pulmonar, perfuração gastrointestinal.
    </>
const Bosentana =
    <>
        alteração da função hepática, nasofaringite, rubor, edema de membros inferiores,
        hipotensão, palpitação, dispepsia, fadiga e prurido; reações adversas menos
        frequentes: anemia, refluxo gastroesofágico e hemorragia retal.
    </>
const Certolizumabe =
    <>
        infecção bacteriana (incluindo tuberculose (pulmonar, extrapulmonar e disseminada)
        e abscessos), infecções virais (incluindo herpes, papiloma vírus, influenza),
        desordens eosinofílicas, leucopenia (incluindo linfopenia e neutropenia), dor de
        cabeça (incluindo enxaqueca), anormalidade sensorial, náusea e vômito, hepatite +
        (incluindo aumento das enzimas hepáticas), pirexia, dor (em qualquer local),
        astenia, prurido (em qualquer local), reação no local de injeção.
    </>

const Ciclofosfamida =
    <>
        diminuição do número de células brancas no sangue, fraqueza, náusea, vômito,
        infecções da bexiga acompanhada ou não de sangramento, problemas nos rins, no
        coração, pulmão, queda de cabelos, aumento do risco de desenvolver cânceres.
    </>

const Ciclosporina =
    <>
        disfunção renal, tremores, aumento da quantidade de pelos no corpo, pressão
        alta, hipertrofia gengival, aumento dos níveis de colesterol e triglicerídios,
        formigamentos, dor no peito, infarto do miocárdio, batimentos rápidos do
        coração, convulsões, confusão, ansiedade, depressão, fraqueza, dores de cabeça,
        unhas e cabelos quebradiços, coceira, espinhas, náusea, vômitos, perda de
        apetite, gastrite, úlcera péptica, soluços, inflamação na boca, dificuldade
        para engolir, hemorragias, inflamação do pâncreas, prisão de ventre, desconforto
        abdominal, síndrome hemolíticourêmica, diminuição das células brancas do sangue,
        linfoma, calorões, hiperpotassemia, hipomagnesemia, hiperuricemia, toxicidade
        para os músculos, disfunção respiratória, sensibilidade aumentada a temperatura
        e reações alérgicas, toxicidade renal e hepática e ginecomastia (aumento das
        mamas no homem).
    </>

const Clobetasol =
    <>
        piora da lesão, surgimento ou piora da coceira, inchaço, dor, ardor ou
        vermelhidão no local onde foi usado o medicamento; em casos de uso prolongado
        e em áreas extensas, alterações na pele, aumento do crescimento dos pelos no
        corpo, sinais e sintomas do excesso de hormônios da adrenal (aumento da pressão
        arterial, aparecimento de espinhas, estrias, inchaços, ganho de peso inesperado,
        dor óssea, problemas nos olhos, dor de cabeça).
    </>

const Codeina =
    <>
        sonolência, constipação intestinal, náusea e vômitos nas primeiras doses,
        reações alérgicas, dificuldade de respirar, confusão mental, visão dupla
        ou nublada, boca seca, perda de apetite, dificuldade para urinar.
    </>

const Danazol =
    <>
        reações adversas mais comuns incluem náuseas, vômitos, diarreia, dor de
        cabeça, nervosismo, desorientação, fraqueza, convulsões, ganho de peso,
        inchaço, alterações do paladar, aumento da pressão arterial, perda de
        potássio, insuficiência cardíaca congestiva.
    </>

const Etanercepte = Adalimumabe
// é o mesmo que o do Adalimumabe

const Gabapentina =
    <>
        diminuição das células brancas do sangue, constipação, secura na boca,
        náuseas e vômitos, tontura, sonolência, cansaço, depressão, confusão,
        nervosismo, descoordenação, amnésia, ganho de peso, visão turva ou
        dupla, coceira na pele, rinite, bronquite, faringite, tosse e infecções
        respiratórias, edema periférico, febre.
    </>

const Golimumabe =
    <>
        infecções bacterianas (incluindo septicemia e pneumonia), micobacterianas
        (tuberculose), fúngicas invasivas e oportunistas, reativação do vírus da
        hepatite B, insuficiência cardíaca congestiva, distúrbios desmielinizantes
        do sistema nervoso central, pancitopenia, leucopenia, neutropenia,
        agranulocitose e trombocitopenia.
    </>
const Imunoglobulina =
    <>
        dor de cabeça, calafrios, febre, reações no local de aplicação da injeção
        que incluem dor, coceira e vermelhidão, aumento de creatinina e uréia no
        sangue, seguido de oligúria e anúria, insuficiência renal aguda, necrose
        tubular aguda, nefropatia tubular proximal, nefrose osmótica.
    </>

const Infliximabe = Adalimumabe

const Leflunomida =
    <>
        diarreia, náusea, vômitos, anorexia, distúrbios da mucosa oral (por
        exemplo: estomatite aftosa, ulcerações na boca), dor abdominal, elevação
        dos parâmetros laboratoriais hepáticos (por exemplo: transaminases, menos
        frequentemente gama-GT, fosfatase alcalina, bilirrubina), colite
        incluindo colite microscópica; elevação da pressão sanguínea. Leucopenia
        com contagem de leucócitos maior que 2 x 109/L (2 g/L); anemia, trombocitopenia
        com contagem de plaquetas menor que 100 x 109/L (100 g/L). Cefaleia, vertigem e
        parestesia; distúrbios do paladar e ansiedade. Reações alérgicas leves
        (incluindo exantema maculopapular e outros), prurido, eczema, pele
        ressecada, aumento da perda de cabelo. Urticária; perda de peso e
        astenia; hipopotassemia.
    </>

const Mesalazina =
    <>
        dores de cabeça, reações alérgicas (dores nas juntas, febre, coceira,
        erupção cutânea), sensibilidade aumentada aos raios solares, queda de
        cabelo, dores abdominais, náusea, vômitos, perda de apetite, diarreia,
        diarreia com sangue, tonturas, rinite, cansaço ou fraqueza; efeitos
        adversos mais raros: hepatite medicamentosa, pancreatite e pericardite.
    </>

const Micofenolato =
    <>
        diarreia, diminuição das células brancas do sangue, infecção generalizada
        e vômitos, dor no peito, palpitações, pressão baixa, trombose,
        insuficiência cardíaca, hipertensão pulmonar, morte súbita, desmaio,
        ansiedade, depressão, rigidez muscular, trombocitopenia, hiperlipemia,
        formigamentos, sonolência, neuropatia, convulsões, alucinações,
        vertigens, tremores, insônia, tonturas, queda de cabelo, aumento da
        quantidade de pelos no corpo, coceiras, ulcerações na pele, espinhas,
        vermelhidão da pele, prisão de ventre, náusea, azia e dor de estômago,
        perda de apetite, gases, gastrite, gengivite, problemas na gengiva,
        hepatite, sangue na urina, aumento da frequência ou retenção urinária,
        insuficiência renal, desconforto para urinar, impotência sexual,
        anemia, diminuição das plaquetas do sangue, diabete melito,
        hipotireoidismo, inchaço, alteração de eletrólitos (hipofosfatemia,
        hipocalemia, hipercalemia, hipocloremia), hiperglicemia,
        hipercolesterolemia, alteração de enzimas hepáticas, febre, dor de
        cabeça, fraqueza, dor nas costas e no abdômen, pressão alta,
        falta de ar, tosse.
    </>

const Naproxeno =
    <>
        dor abdominal, sede, constipação, diarreia, dispneia, náusea,
        estomatite, azia, sonolência, vertigens, enxaquecas, tontura,
        erupções cutâneas, prurido, sudorese, ocorrência de distúrbios
        auditivos e visuais, palpitações, edemas, dispepsia e púrpura.
    </>

const Metilprednisolona =
    <>
        retenção de líquidos, aumento da pressão arterial, problemas no
        coração, fraqueza nos músculos, problema nos ossos (osteoporose),
        problemas de estômago (úlceras), inflamação do pâncreas (pancreatite),
        dificuldade de cicatrização de feridas, pele fina e frágil,
        irregularidades na menstruação, e manifestação de diabete mélito;
    </>

const Metotrexato =
    <>
        convulsões, encefalopatia, febre, calafrios, sonolência, queda de
        cabelo, espinhas, furúnculos, alergias de pele leves a graves,
        sensibilidade à luz, alterações da pigmentação da pele e de mucosas,
        náusea, vômitos, perda de apetite, inflamação da boca, úlceras de
        trato gastrointestinal, hepatite, cirrose e necrose hepática,
        diminuição das células brancas do sangue e das plaquetas, insuficiência
        renal, fibrose pulmonar e diminuição das defesas imunológicas do
        organismo com ocorrência de infecções.
    </>

const Hidroxicloroquina =
    <>
        distúrbios visuais com visão borrada e fotofobia, edema macular,
        pigmentação anormal, retinopatia, atrofia do disco óptico,
        escotomas, diminuição da acuidade visual e nistagmo; problemas
        emocionais, dores de cabeça, tonturas,
        movimentos involuntários, cansaço, branqueamento e queda de
        cabelos, mudanças da cor da pele e alergias leves a graves,
        náusea, vômitos, perda de apetite, desconforto abdominal,
        diarreia, parada na produção de sangue pela medula óssea (anemia
        aplásica), parada na produção de células brancas pela medula
        óssea (agranulocitose), diminuição de células brancas do sangue
        e de plaquetas, destruição das células do sangue (hemólise);
        miopatia, paralisia, zumbido e surdez.
    </>

const Natalizumabe =
    <>
        dor de cabeça, tontura, vômitos, náusea, alergias, arrepios,
        cansaço e alterações nas enzimas do fígado, leucoencefalopatia
        multifocal progressiva (LEMP).
    </>

const Pamidronato =
    <>
        febre, cansaço, sonolência ou insônia, náusea, perda do apetite,
        aumento dos batimentos do coração, aumento da pressão arterial,
        prisão de ventre, aftas, dor no local da aplicação e diminuição
        das células do sangue (células brancas e plaquetas).
    </>

const Prednisona =
    <>
        aumento do apetite, úlcera gástrica com possível perfuração e
        sangramento, inflamação do pâncreas, cansaço, insônia, catarata,
        aumento da pressão dentro do olho, glaucoma, olhos inchados,
        aumento da ocorrência de infecção do olhos por fungos e vírus,
        diabetes e aumento dos valores de colesterol.
    </>

const Prednisolona = Prednisona

const Raloxifeno =
    <>
        câimbras nas pernas, fogachos, formação de coágulos nas veias
        profundas das pernas, inchaço, náusea, vômitos, dores
        abdominais e dor de cabeça.
    </>

const Risedronato =
    <>
        dores abdominais, náusea, diarreia, gases, dor no estômago,
        depressão, tonturas, insônia, ansiedade, dores nos músculos,
        câimbras, formigamentos, aumento da pressão arterial, dor no
        peito, falta de ar, vermelhidão e coceira na pele e infecções.
    </>

const Rituximabe =
    <>
        infecção do trato respiratório superior, infecções do trato
        urinário; bronquite, sinusite, gastroenterite, pé-de-atleta;
        neutropenia; hipertensão, náusea, erupção cutânea, pirexia,
        prurido, urticária, irritação na garganta, rubor quente,
        hipotensão, rinite, tremores, taquicardia, fadiga, dor orofaríngea,
        edema periférico, eritema; edema generalizado, broncoespasmo,
        sibilo, edema na laringe, edema angioneurótico, prurido generalizado,
        anafilaxia, reação anafilactoide, hipercolesterolemia; cefaleia;
        parestesia; enxaqueca, tontura, ciática; alopecia; depressão,
        ansiedade; dispepsia, diarreia, refluxo gastroesofágico, úlcera
        oral, dor abdominal superior; artralgia/dor; musculoesquelética,
        osteoartrite, bursite; níveis reduzidos de IgM; níveis reduzidos
        de IgG; angina pectoris, fibrilação e flutter atrial.
    </>

const Sildenafila =
    <>
        vermelhidão, dores de cabeça, dificuldade de digestão, diarreia
        e dor em braços e pernas, gripe, febre, tosse, visão turva e
        dificuldade para dormir.
    </>

const Tocilizumabe =
    <>
        reações no local da aplicação da injeção e durante a infusão,
        alergias, coceira, urticária, dor de cabeça, tonturas, aumento
        da pressão sanguínea, tosse, falta de ar, feridas na boca, aftas,
        dor abdominal e risco aumentado a uma variedade de infecções,
        como infecções de vias aéreas superiores, celulite, herpes
        simples e herpes zoster, alterações nos exames laboratoriais +
        (aumento das enzimas do fígado, bilirrubinas, aumento do
        colesterol e triglicerídeos).
    </>

const Tofacitinibe =
    <>
        aumento da taxa de infecções, reativação viral, trombose venosa
        profunda, malignidade e distúrbio linfoproliferativo, perfurações
        gastrintestinais, hipersensibilidade, linfopenia, neutropenia,
        diminuição dos níveis de hemoglobina, aumento nos parâmetros
        lipídicos, elevação das enzimas hepáticas
    </>

const Secuquinumabe =
    <>
        reações no local da aplicação (como dor e coceira), dor de
        cabeça, tosse, náusea, vômitos, febre, cansaço, alteração na
        pressão arterial até reações mais graves, que incluem 
        infecções oportunístas fúngicas e bacterianas como 
        tuberculose, histoplasmose, aspergilose e nocardiose, 
        podendo, em casos raros, ser fatal
    </>

const Sulfassalazina =
    <>
        dores de cabeça, aumento da sensibilidade aos raios solares,
        alergias de pele graves, dores abdominais, náusea, vômitos,
        perda de apetite, diarreia, hepatite, dificuldade para engolir,
        diminuição do número dos glóbulos brancos no sangue, parada na
        produção de sangue pela medula óssea (anemia aplásica), anemia
        por destruição aumentada dos glóbulos vermelhos do sangue
        (anemia hemolítica), diminuição do número de plaquetas no sangue,
        falta de ar associada a tosse e febre (pneumonite intersticial),
        dores articulares, cansaço e reações alérgicas.
    </>

const Upadacitinibe =
    <>
        aumento da taxa de infecções; reativação viral; neutropenia;
        linfopenia; anemia; aumentos nos parâmetros lipídicos; elevações
        de enzimas hepáticas; tromboembolismo venoso. O perfil de
        segurança em longo prazo do upadaci􀆟nibe ainda não está bem
        estabelecido.
    </>

const Meds = [
    ["Abatacepte", Abatacepte],
    ["Adalimumabe", Adalimumabe],
    ["Azatioprina", Azatioprina],
    ["Baricitinibe", Baricitinibe],
    ["Bosentana", Bosentana],
    ["Certolizumabe", Certolizumabe],
    ["Ciclofosfamida", Ciclofosfamida],
    ["Ciclosporina", Ciclosporina],
    ["Clobetasol", Clobetasol],
    ["Codeína", Codeina],
    ["Danazol", Danazol],
    ["Etanercepte", Etanercepte],
    ["Gabapentina", Gabapentina],
    ["Golimumabe", Golimumabe],
    ["Imunoglobulina Humana", Imunoglobulina],
    ["Infliximabe", Infliximabe],
    ["Leflunomida", Leflunomida],
    ["Mesalazina", Mesalazina],
    ["Metilprednisolona", Metilprednisolona],
    ["Micofenolato de mofetila", Micofenolato],
    ["Naproxeno", Naproxeno],
    ["Metotrexato", Metotrexato],
    ["Hidroxicloroquina", Hidroxicloroquina],
    ["Natalizumabe", Natalizumabe],
    ["Pamidronato", Pamidronato],
    ["Prednisona", Prednisona],
    ["Prednisolona", Prednisolona],
    ["Raloxifeno", Raloxifeno],
    ["Risedronato", Risedronato],
    ["Rituximabe", Rituximabe],
    ["Sildenafila", Sildenafila],
    ["Tocilizumabe", Tocilizumabe],
    ["Tofacitinibe", Tofacitinibe],
    ["Secuquinumabe", Secuquinumabe],
    ["Sulfassalazina", Sulfassalazina],
    ["Upadacitinibe", Upadacitinibe],
]

const Adverso = ({ medicamentos }) => {

    const Conteudo = ({ medicamento }) => {

        let inicio = <>Estou ciente sobre o <strong>efeitos adversos</strong> do {medicamento} são: </>

        let texto = Meds.filter(m => m[0] === medicamento).map(x => x[1])

        return <>{inicio}<br />{texto}</>
    }

    return (
        <>
            {medicamentos.map((m, i) =>
                <div key={i} >
                    <Conteudo medicamento={m} />
                </div>
            )}
        </>
    )

}

export default Adverso
